import { hostUrlConverter } from '../../../../util';

export const AdsBannerCardButtons = ({ productURL, productButtonName }) => {
    const learnMoreURL = 'yearbooks/students-and-parents/yearbook-ads'

    return (
        <div>
            <span className="my-3 d-inline-block">
                <a href={hostUrlConverter(productURL)} className="ads-button btn">{productButtonName}</a>
            </span>
            <span className="learnmore-button">
                <a href={hostUrlConverter(learnMoreURL)} className="ads-button btn">Learn More</a>
            </span>
        </div>
    )
}